export enum ColumnFieldType {
  Text,
  Hyperlink,
  Image,
  User,
  Boolean,
  DateTime,
  Currency,
  Counter,
  Number,
  Note,
  Computed,
  Name,
  FileSize,
  Shared,
  SharedWith,
  FileIcon,
  DotDotDot,
  Tag,
  Lookup,
  Taxonomy,
  Hashtag,
  Attachments,
  AverageRating,
  Title,
  WorkflowStatus,
  ProgressBar,
  RatedBy,
  Ratings,
  LikedBy,
  Likes,
  ComplianceRecordFlag,
  Custom,
  Activity,
  Choice,
  ClientSideCustom,
  FileActivity,
  MruName,
  ShareCommand,
  PinCommand,
  Thumbnail,
  ImageSize,
  Location,
  Geolocation
}

export default ColumnFieldType;
